import { TFunction } from 'i18next'

// all the mutation name used in frontend, in the pms and portal,
// if a mutation name is changed in the .api file, then it must be changed here too
export const MUTATION_NAMES = [
  'GenerateCityTaxFile',
  'SendInvoideToTSDigital',
  'UpdateInvoiceState',
  'SendReceiptToFiscalGateway',
  'CreatePaidInFullDocument',
  'DeleteDocument',
  'SendPaymentLinkEMailForUnpaidDocuments',
  'CreateLinkForUnpaidDocument',
  'SendReminderEmailForUnpaidDocuments',
  'UpdateInvoiceCustomFields',
  'PropertyNew',
  'PropertyUpdate',
  'PropertyDelete',
  'SetPropertySubAddresses',
  'CreateBill',
  'UpdateBill',
  'DeleteBill',
  'UpdatePriceCalendar',
  'UpdatePriceCalendarRange',
  'MoveProductionAssigned',
  'SplitProductionAssigned',
  'deleteProduction',
  'UpdateProduction',
  'SendPs',
  'SendIstat',
  'GenerateIstatFile',
  'ReservationCreate',
  'ReservedResourceCreate',
  'CreateDeposit',
  'DeleteDeposit',
  'CreateCheckoutDocument',
  'ReservationDelete',
  'ReservationUpdate',
  'ReservedResourceUpdate',
  'DeleteReservedResource',
  'ReservedResourcesCheckIn',
  'ReservedResourcesCheckOut',
  'UpdateReservedResources',
  'UndoCheckinReservedResources',
  'UndoCheckoutReservedResources',
  'CreateChargeForReservation',
  'CreateResourceUnavailability',
  'UpdateResourceUnavailability',
  'DeleteResourceUnavailability',
  'CustomerNew',
  'CustomerUpdate',
  'CustomerDelete',
  'SendReservationEmail',
  'SendPosLink2PayEmail',
  'SetNcsUserPreference',
  'SetNcsNotificationRead',
  'SetNcsNotificationsRead',
  'CreateRate',
  'UpdateRate',
  'DeleteRate',
  'HorecahubRegisterIntegration',
  'SetResourceCleaningState',
  'ExportDatabase',
  'ImportProperty',
  'ImportPropertyRetry',
  'AttachDatabaseForExport',
  'CreateExportScripts',
  'UpdateSupportUserRole',
  'OnboardingProperty',
  'ConfirmQuotation',
  'DeleteQuotation',
  'SetQuotationState',
  'SendQuotationEmail',
  'CreateQuotation',
  'UpdateQuotation',
  'AccountingDataExportStart',
  'AccountingDataExportCreateConfiguration',
  'AccountingDataExportUpdateConfiguration',
  'AccountingDataExportUpdatePaymentActive',
  'AccountingDataExportUpdateCashDeskType',
  'CreateAdditionalService',
  'DeleteAdditionalService',
  'UpdateAdditionalService',
  'SetPropertyFiscalConfiguration',
  'DeleteCashDeskType',
  'BookingPolicyNew',
  'BookingPolicyUpdate',
  'BookingPolicyDelete',
  'CreateDocumentActive',
  'UpdateDocumentActive',
  'DeleteDocumentActive',
  'CreateCashDeskType',
  'UpdateCashDeskType',
  'AddCassaInCloudApiKey',
  'UpdateCassaInCloudApiKey',
  'RemoveCassaInCloudApiKey',
  'ActivatePointOfSales',
  'UpdatePointOfSale',
  'GenerateCiCTenantSecret',
  'CreateChannel',
  'UpdateChannel',
  'DeleteChannel',
  'RetrieveFutureReservations',
  'SendAvailabilitiesAndPrices',
  'RetrieveReservations',
  'CreateChargeCategory',
  'DeleteChargeCategory',
  'EditChargeCategory',
  'SetPropertyCityTaxConfiguration',
  'SetPropertyFelConfiguration',
  'HotelDateUpdate',
  'UpdateHousekeepingSettings',
  'FileUploadPresignedURL',
  'SetEntityImages',
  'Insight',
  'SetPropertyIstatConfiguration',
  'CreateMailTemplate',
  'UpdateMailTemplate',
  'DeleteMailTemplate',
  'SendDataHubSpot',
  'SetPropertyConfigurations',
  'PaymentMethodNew',
  'PaymentMethodUpdate',
  'PaymentMethodDelete',
  'UpdatePaymentActive',
  'CreatePaymentActive',
  'CreatePosition',
  'UpdatePosition',
  'DeletePosition',
  'UpdatePrivacySettings',
  'CreateProduct',
  'UpdateProduct',
  'DeleteProduct',
  'SetPropertyPsConfiguration',
  'CreateResourceType',
  'DeleteResourceType',
  'UpdateResourceType',
  'OnboardingResourceType',
  'CreateResource',
  'UpdateResource',
  'DeleteResource',
  'TagNew',
  'TagUpdate',
  'TagDelete',
  'StartTsPayOnboarding',
  'CreateLinkFroReservation',
  'CreateLink2PayPosOnline',
  'UpdateUserRole',
  'CreateUserAndRole',
  'VatNew',
  'VatUpdate',
  'VatDelete',
  'UpdateSinapsiPriceCalendar',
  'SetPropertySinapsiConfiguration',
  'UpdateThread',
  'DeleteInternalThreadMessage',
  'SendThreadMessage',
  'CreateFiscalGatewayWorkstation',
  'CreateCoDocument',
  'UpdateCoDocument',
  'UpdateFinalizedDocument',
  'FinalizeCoDocument',
  'DeleteCoDocument',
  'UndoCoDocument',
  'CreateCreditNote',
  'CreateCreditNoteForAdvance',
  'CreateManualDocument',
  'CreateCustomer',
  'CreateQuotationForIBE',
  'CreateAvailabilityRequest',
  'GuestPortalAddServices',
  'GuestPortalCancelReservation',
  'GuestPortalWebCheckin',
  'CreateProduction',
] as const

type MutationName = typeof MUTATION_NAMES[number]

export default function translateOperationName({ operationName, t }: { operationName: string; t: TFunction }) {
  if (MUTATION_NAMES.includes(operationName as MutationName)) {
    return t(`pms.audits.grid.operation_name.${operationName}`)
  }
  if (operationName?.startsWith('lambda')) {
    return t('pms.audits.grid.operation_name.lambda')
  }
  if (operationName.includes('/tspay/callback/onboarding')) {
    return t('pms.audits.grid.operation_name.tspay_onboarding')
  }
  if (operationName.includes('/tspay/callback/source')) {
    return t('pms.audits.grid.operation_name.tspay_source')
  }
  if (operationName.includes('/tspay/callback/charge')) {
    return t('pms.audits.grid.operation_name.tspay_charge')
  }

  return operationName
}
